@if (openningHoursString()) {
  <div class="flex items-center gap-1">
    <app-ui-icon
      color="var(--grey-4)"
      name="clock"
      size="sm"
    >
    </app-ui-icon>
    <span class="opening-hours body-4 text-grey-0">{{
        openningHoursString()
      }}</span>
  </div>
}

